import React from 'react';
import { JobData } from '../../api/JobsService';
import { getStateAbbreviation } from '../../utils/dataUtils';

interface JobTooltipProps {
  job: JobData;
  position: 'bottom' | 'right';
  show: boolean;
  isMobile?: boolean;
}

const JobTooltip: React.FC<JobTooltipProps> = ({ job, position, show, isMobile = false }) => {
  const isSmallerMobile = window.innerWidth <= 375; // smaller then normal mobile (i.e galaxy z fold 5, iphone SE)
  if (!show) return null;

  const isBottom = position === 'bottom';

  return (
    <div 
      data-testid="tooltip-container" 
      className="bg-white border rounded shadow" 
      style={{
        zIndex: 1000, 
        position: 'absolute', 
        top: isBottom ? '100%' : '50%',
        left: isBottom ? '50%' : '100%',
        transform: isBottom ? 'translateX(-50%)' : 'translateY(-50%)',
        marginTop: isBottom ? '8px' : '4rem',
        marginLeft: isBottom ? '0px' : '8px',
        width: isSmallerMobile ? '230px' : isMobile ? '250px' : '300px'
        // minWidth: '250px',
        // maxWidth: '350px'
      }}
    >
      <div 
        data-testid="tooltip-content" 
        className="base-tooltip-content position-relative p-3 text-dark"
      >
        <div id="content">
          <p className="mb-1" style={{ fontWeight: '500' }}>{job.title}</p>
          <p className="mb-0 text-base" style={{ fontWeight: '400' }}>
            {job.locations[0].city}, {getStateAbbreviation(job.locations[0].region)}
          </p>
          <p className="mb-0 text-base" style={{ fontWeight: '400' }}>
            Req ID: {job.requisitionName || 'N/A'}
          </p>
        </div>
      </div>
      <div 
        className="tooltip-arrow" 
        style={{
          position: 'absolute', 
          top: isBottom ? '-6px' : '50%', 
          left: isBottom ? '50%' : '-6px', 
          transform: isBottom 
            ? 'translateX(-50%) rotate(45deg)' 
            : 'translateY(-50%) rotate(45deg)'
        }}
      />
    </div>
  );
};

export default JobTooltip;